module.exports = __webpack_public_path__ + "img/icon_submenu10.16d76681.svg";